import type { SpaceScale } from '@gousto-internal/citrus-react';
import { FullBleedContainer } from './FullBleedRailWrap.styles';

export type FullBleedRailWrapProps = {
  readonly paddingLeftMobile: SpaceScale;
  readonly paddingRightMobile: SpaceScale;
  readonly paddingLeftDesktop: SpaceScale;
  readonly paddingRightDesktop: SpaceScale;
  readonly children: React.ReactNode;
};

export function FullBleedRailWrap({
  paddingLeftMobile,
  paddingRightMobile,
  paddingLeftDesktop,
  paddingRightDesktop,
  children,
}: FullBleedRailWrapProps): JSX.Element {
  return (
    <FullBleedContainer
      data-testid="full-bleed-rail-wrap"
      paddingLeftMobile={paddingLeftMobile}
      paddingRightMobile={paddingRightMobile}
      paddingLeftDesktop={paddingLeftDesktop}
      paddingRightDesktop={paddingRightDesktop}
    >
      {children}
    </FullBleedContainer>
  );
}
